import { __rest } from "tslib";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { Box } from '../..';
const presetComponent = {
  'paragraph-xl': 'p',
  'paragraph-l': 'p',
  'paragraph-m': 'p',
  'paragraph-s': 'p',
  'label-3xl': 'span',
  'label-xxl': 'span',
  'label-xl': 'span',
  'label-l': 'span',
  'label-m': 'span',
  'label-s': 'span',
  'label-up-m': 'span',
  'label-up-s': 'span'
};
export const TextPreset = _a => {
  var {
    children,
    component,
    preset
  } = _a,
      allRest = __rest(_a, ["children", "component", "preset"]);

  return _jsx(Box, Object.assign({
    textPreset: preset,
    component: component !== null && component !== void 0 ? component : presetComponent[preset]
  }, allRest, {
    children: children
  }));
};
export const TextPresetRenderer = _a => {
  var {
    children
  } = _a,
      allProps = __rest(_a, ["children"]);

  return isTextPresetElement(children) ? _jsx(_Fragment, {
    children: children
  }) : _jsx(TextPreset, Object.assign({}, allProps, {
    children: children
  }));
};
export const isTextPresetElement = el => React.isValidElement(el) && el.type === TextPreset;
//# sourceMappingURL=TextPreset.js.map